import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field, useFormikContext } from "formik";
import {
  Col,
  Container,
  Row,
  Button,
  FormGroup,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { ReactstrapInput } from "reactstrap-formik";

import * as Yup from "yup";

import FormHelpers from "../../helpers/FormHelpers";
import ScrollToFieldError from "./Validation/ScrollToFieldError";
import InfoTooltip from "../UI/Progress/InfoTooltip";

import { configuratorActions } from "../../store/configurator-slice";

function RequestForm() {
  const dispatch = useDispatch();

  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const requestDetails = currentRequest.DonorRequest;

  const isUpdating = requestDetails.Id;

  let prices = currentRequest.DonationAmounts.split("|");

  const formRef = useRef(null);

  const validationRules = {
    cardType: Yup.string().required("Required"),
    amount: Yup.string().required("Please select an amount"),
    customAmount: Yup.number()
      .typeError("Please enter a donation amount of at least $1.00.")
      .when("amount", (amount) => {
        if (amount == "other")
          return Yup.number()
            .typeError("Please enter a donation amount of at least $1.00.")
            .min(1, "Please enter a donation amount of at least $1.00.")
            .required("Please enter a donation amount of at least $1.00.");
      }),
  };

  let donationAmount = "";
  let donationCustomAmount = "";
  let defaultPriceFound = false;

  prices.forEach((price) => {
    if(Number(price) == Number(requestDetails.OfferingAmount)) {
      defaultPriceFound = true;
    }
  });

  if(defaultPriceFound) {
    donationAmount = String(Number(requestDetails.OfferingAmount).toFixed(2));
  } else {
    if(requestDetails.OfferingAmount) {
      donationAmount = "other";
      donationCustomAmount = String(Number(requestDetails.OfferingAmount).toFixed(2));
    }
  }

  const formSchema = Yup.object().shape(validationRules);

  function formSubmitHandler(values) {
    // if request is a no card, add to cart right now and move to last step
    dispatch(configuratorActions.setRequest(values));
    FormHelpers.scrollToTop();
  }

  function cardTypeClickHandler(event) {
    dispatch(configuratorActions.setCardType(event.target.value));
  };

  return (
    <div className="cfg-input-form cfg-request" data-step="request">
      <Formik
        initialValues={{
          cardType: requestDetails.CardTypeValue,
          amount: donationAmount,
          customAmount: donationCustomAmount,
        }}
        validationSchema={formSchema}
        onSubmit={formSubmitHandler}
        innerRef={formRef}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form className="text-start">
            <ScrollToFieldError />
            <Container className="cfg-form-section">
            
              <Row>
                <Col xs="12">
                  <h4 className="required">Send To:</h4>
                  <FormGroup>
                  <div className="form-check">
                      <label>
                        <Field
                          type="radio"
                          name="cardType"
                          value="sendtome"
                          onClick={cardTypeClickHandler}
                        />
                        Yes, please send to me.
                      </label>
                    </div>
                    <div className="form-check">
                      <label>
                        <Field
                          type="radio"
                          name="cardType"
                          value="sendtosomeone"
                          onClick={cardTypeClickHandler}
                        />
                        Yes, send to someone else for me
                      </label>
                    </div>
                    {errors.cardType && touched.cardType && (
                      <div className="invalid-feedback">{errors.cardType}</div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <div className="mb-3">
                    <h4 className="required">My offering to support the Capuchin missionaries is:</h4>

                    {prices.map((price) => (
                      <div className="form-check" key={price}>
                        <label>
                          <Field
                            type="radio"
                            name="amount"
                            value={price.toString()}
                            onChange={handleChange}
                          />
                          ${price}
                        </label>
                      </div>
                    ))}

                    <div className="form-check">
                      <label>
                        <Field
                          type="radio"
                          name="amount"
                          value="other"
                          onChange={handleChange}
                        />
                        Other
                      </label>
                    </div>

                    {errors.amount && touched.amount && (
                      <div className="invalid-feedback">{errors.amount}</div>
                    )}

                    {values.amount === "other" && (
                      <div>
                        <label>
                          $ <Field type="text" name="customAmount" />
                        </label>
                      </div>
                    )}

                    {errors.customAmount && touched.customAmount && (
                      <div className="invalid-feedback">
                        {errors.customAmount}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>

              {/* <DebugOutput
                errors={errors}
                values={FormHelpers.getValues(values)}
              /> */}
            </Container>
            <Button
              type="submit"
              size="sm"
              color="primary"
              className="float-end"
            >
              Next
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default RequestForm;
